import { isOONGroup, isExternalProvider } from '.';

export default function isExternalProviderOrOONGroup(group) {
  return isOONGroup(group) || isExternalProvider(group);
}
